import React from 'react';
import { Grid, Container, Divider } from '@material-ui/core';
import LoadingCheckPae from './ComponetsPae/LoadingCheckPae';

const LoadPaePage = ({ momentsStatusList, teme, valueForm }) => {
  return (
    <Container maxWidth="sm">
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '50px',
          border: '1px solid #E5E7EB',
          borderRadius: '20px',
          backgroundColor: '#ffffff',
          paddingBottom: '5px'
        }}
      >
        <Grid
          item
          container
          xs={12}
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <div
              style={{
                width: '285px',
                height: '11px',
                borderRadius: '0px 0px 20px 20px',
                backgroundColor: `${teme.primary}`
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'
              }}
            >
              <i
                class="fas fa-magic"
                style={{
                  width: '49px',
                  height: '49px',
                  fontSize: '48px',
                  zIndex: '1'
                }}
              />
              <div
                style={{
                  backgroundColor: `${teme.primary}`,
                  width: '67px',
                  height: '20px',
                  marginTop: '-13px'
                }}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center'
              }}
            >
              <label
                style={{
                  color: '#000000',
                  fontFamily: 'Public Sans',
                  fontSize: '24px',
                  fontWeight: 600
                }}
              >
                Estamos construindo seu
                <label
                  style={{
                    width: '322px',
                    color: `${teme.primary}`,
                    fontFamily: 'Public Sans',
                    fontSize: '24px',
                    fontWeight: 600
                  }}
                >
                  {valueForm.plan && valueForm.plan.label}
                </label>
              </label>
            </div>
          </Grid>

          <Grid item xs={12}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center'
              }}
            >
              <label
                style={{
                  width: '297px',
                  color: '#4A4F58',
                  fontFamily: 'Public Sans',
                  fontSize: '14px',
                  fontWeight: 400
                }}
              >
                Este processo pode levar alguns minutos. Acompanhe o abaixo
                enquanto a mágica acontece.
              </label>
            </div>
          </Grid>

          {momentsStatusList &&
            momentsStatusList.map((x, index) => (
              <>
                <Grid item container xs={10}>
                  <div
                    style={{ justifyContent: 'center', alignItems: 'center' }}
                  >
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <LoadingCheckPae
                        label={'Construindo ' + x.alias_name}
                        status={x.status}
                        teme={teme}
                      />
                    </Grid>
                    {index + 1 !== momentsStatusList.length && (
                      <>
                        <Grid item xs={12}>
                          <div
                            style={{
                              width: '2.5px',
                              height: '15px',
                              marginTop: '-7px',
                              marginLeft: '5px'
                            }}
                          >
                            <Divider
                              orientation="vertical"
                              style={{
                                color: '#CFD2D9',
                                width: '2.5px',
                                height: '15px'
                              }}
                            />
                          </div>
                        </Grid>
                      </>
                    )}
                  </div>
                </Grid>
              </>
            ))}
        </Grid>
      </div>
    </Container>
  );
};

export default LoadPaePage;
